import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faFile, faSave } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button } from 'reactstrap';

//Components
import TextField from '../../../../../components/TextField';
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../../../components/Modal/Modal';

//Constants
import { actionsTable } from '../../../../../constants/MaterialTable';

//Context
import { useAuth } from '../../../../../context/auth';

//Helpers
import { validarCampos, objCampo } from '../../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../../helpers/mascaras';
import { showMessage, showQuestion } from '../../../../../helpers/message';

//Api
import formulario_api from '../../../../../api/formulario_api';
import infracoes_api from '../../../../../api/infracoes_api';

function initialStateQuestao(formulario_id) {
    return {
        questao: "",
        sequencia: "",
        tipoValor: "",
        obrigatorio: "false",
        possuiDependencia: "false",
        deletado: "false",
        tirarFoto:"Obrigatorio",
        formulario_id: formulario_id
    }
}

// function initialStateQuestaoDependente(formularioQuestao_Id) {
//     return {
//         formularioQuestao_Id: formularioQuestao_Id ? formularioQuestao_Id : null,
//         questaoPai_Id: "",
//         questaoPai_Valor: "",
//     }
// }

function initialStateQuestaoOpcao(formularioQuestao_Id) {
    return {
        formularioQuestao_Id: formularioQuestao_Id ? formularioQuestao_Id : null,
        infracao_Id: null,
        valor: "",
    }
}

export default function Questoes({ formulario, loadFormulario, editavel = false }) {
    const { setLoading } = useAuth();

    //Estado de controle dos erros
    const [errors, setErrors] = useState({});

    //Estado de controle dos erros
    const [errorsOpcao, setErrorsOpcao] = useState({});

    //Estado de controle dos dados da questão
    const [questao, setQuestao] = useState(initialStateQuestao(formulario.id));

    //Estado de controle da lista de infracao, para caso de tipo do valor seja uma lista.
    const [infracoes, setInfracoes] = useState([]);

    //Estado de controle da visibilidade do formulario de adicionar questões
    const [visibleForm, setVisibleForm] = useState(false);

    const [opcao, setOpcao] = useState(initialStateQuestaoOpcao());

    const toggleForm = () => {
        setVisibleForm(!visibleForm);
        if (visibleForm) {
            setQuestao(initialStateQuestao(formulario.id));
            setOpcao(questao?.id);
            setErrors({});
        }
    }

    // Estado para abrir o modal
    const [visibilidadeModal, setVisibilidadeModal] = useState(false);

    const toggleModal = () => {
        setOpcao(initialStateQuestaoOpcao());
        setVisibilidadeModal(!visibilidadeModal);
    };

    // função para recarregar as infraçoes
    const loadInfracoes = () => {
        setLoading(true);
        infracoes_api.getList().then(response => {
            response.data.map(value => {
                value.value = value.id.toString();
                value.label = value.identificacao;
                return value;
            });

            setInfracoes(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadInfracoes();
    }, []);

    const optionsTipoValor = [
        { value: "", label: "Selecione uma opção" },
        { value: "Texto", label: "Texto" },
        { value: "Número", label: "Número" },
        { value: "Data", label: "Data" },
        { value: "Lista", label: "Lista" },
    ]

    //Campos obrigatorios no cadastro de uma questão
    const [campos, setCampos] = useState([
        objCampo({ name: "questao", required: true }),
        objCampo({ name: "sequencia", required: true }),
        objCampo({ name: "tipoValor", required: true }),
        objCampo({ name: "obrigatorio", required: true }),
        objCampo({ name: "possuiDependencia", required: true })
    ]);

    const camposQuestaoDependente = [
        objCampo({ name: "questaoPai_Id", required: true }),
        objCampo({ name: "questaoPai_Valor", required: true }),
    ]

    const visualizar = (rowData) => {
        setQuestao(rowData);
        setVisibleForm(true);
    }

    const editar = (rowData) => {
        setQuestao(rowData);
        setVisibleForm(true);
    }

    const remover = (rowData) => {
        showQuestion("Tem certeza?", "Tem certeza de que deseja deletar essa questão?\n Esta ação é irreversível", "info",
            (confirmation) => {
                if (confirmation) {
                    setLoading(true);
                    formulario_api.deleteFormularioQuestao(rowData.id).then(response => {
                        showMessage("Sucesso", "Questão removida com sucesso", "success", () => {
                            toggleForm();
                            loadFormulario();
                        })
                    })
                        .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                        .finally(f => setLoading(false));
                }
            })
    }

    //Ações que a tabela terá
    const actions = [
        ...editavel
            ? [actionsTable.editar(editar), actionsTable.remover(remover)]
            : [actionsTable.visualizar(visualizar)]
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "questao", align: "left" },
        { value: "Tipo", objectValue: "tipoValor", align: "left" },
        { value: "Sequência", objectValue: "sequencia", align: "left" },
    ]

    //Função de onChange dos campos das questões
    const onChange = (e) => {
        const { name, value } = e.target;
        const _questao = {
            ...questao,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_questao, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setQuestao(_questao);
    }

    //Função de onChange para o campo de tipo de valor
    const onChangeTipo = (e) => {
        const { name, value } = e.target;
        const _questao = {
            ...questao,
            [name]: value,
            formularioQuestaoOpcos: value == "Lista" ? questao.formularioQuestaoOpcos : []
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_questao, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setQuestao(_questao);
    }

    //Função de salvamento do step
    const salvarQuestao = () => {
        const _errors = validarCampos(questao, campos);

        if (questao.tipoValor == "Lista" && questao.formularioQuestaoOpcos.length == 0) {
            _errors[0]["formularioQuestaoOpcos"] = { message: "" };
            _errors[1].push(objCampo({ name: "formularioQuestaoOpcos", required: true }))
        }

        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return;

        const _questao = { ...questao };

        _questao.obrigatorio = _questao.obrigatorio === "true";
        _questao.deletado = _questao.deletado === "true";

        if (_questao.id) {
            setLoading(true);
            formulario_api.putFormularioQuestao(_questao).then(response => {
                toggleForm();
                loadFormulario();
            })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        } else {
            setLoading(true);
            _questao?.formularioQuestaoOpcos?.map(value => {
                delete value.formularioQuestao_Id;
                return value;
            });
            formulario_api.postFormularioQuestao(_questao).then(response => {
                toggleForm();
                loadFormulario();
            })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        }
    }

    //Cabeçalhos que a tabela opcoes
    const headersQuestoesObcoes = [
        { value: "Valor", objectValue: "valor", align: "left" },
        {
            value: "Gera Infração", objectValue: "geraInfracao", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{questao?.formularioQuestaoOpcos[dataIndex]?.infracao_Id ? "Sim" : "Não"}</>
                }
            }
        }
    ];

    //Função para editar opção do tipo "lista"
    const editarOpcao = (rowData) => {
        setOpcao(rowData);
    }

    //Função para remover opção do tipo "lista"
    const removeOpcao = (rowData) => {
        setQuestao({
            ...questao,
            formularioQuestaoOpcos: [...questao.formularioQuestaoOpcos.filter(op => op.valor !== rowData.valor)]
        })
    }

    const visualizarQuestao = (rowData) => {
        setOpcao(rowData);
    }

    //Ações que a tabela terá
    const actionsOpcao = [
        ...editavel
            ? [actionsTable.editar(editarOpcao), actionsTable.remover(removeOpcao)]
            : [actionsTable.visualizar(visualizarQuestao)]
    ];

    // Lista
    const camposQuestaoOpcao = [
        objCampo({ name: "valor", required: true })
    ];

    //Função para alterar state da lista de opções
    const onChangeOpcoes = (e) => {
        const { name, value } = e.target;
        const _opcao = {
            ...opcao,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = camposQuestaoOpcao.filter(campo => campo.name === name);
        const fieldError = validarCampos(_opcao, _campos);

        const _errors = { ...errors };
        delete _errors[name];

        if (fieldError[1].length === 0)
            setErrorsOpcao({ ..._errors });
        else
            setErrorsOpcao({ ..._errors, ...fieldError[0] });

        setOpcao(_opcao);
    }

    //Função para adicionar no state a lista de opções
    const salavaOpcaoLista = () => {
        const _errors = validarCampos(opcao, camposQuestaoOpcao);

        setErrorsOpcao(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _opcao = {
            ...opcao
        }

        if (!_opcao.formularioQuestao_Id) {
            _opcao.formularioQuestao_Id = questao.id;
        }

        const _questão = {
            ...questao,
            formularioQuestaoOpcos: [...questao.formularioQuestaoOpcos ? questao.formularioQuestaoOpcos : [], _opcao]
        }

        setQuestao(_questão);
        setOpcao(initialStateQuestaoOpcao(questao.id));
    }

    //Função do campo tipo select
    const onChangeInfracoes = (value, e) => {
        setOpcao({
            ...opcao,
            [e.name]: value ? value.value : null,
        });
    }

    return (
        <>
            <h5 className='mb-3 d-flex align-items-center justify-content-between'>Questões {editavel ? <Button color='success' onClick={toggleForm}>+ Adicionar</Button> : <></>}</h5>
            <div className={`formContainer ${!visibleForm ? "close" : ""}`}>
                <Row className='mx-4'>
                    <Col md="12" lg="4">
                        <TextField
                            mask={mascaras.numeroMask}
                            name={"sequencia"}
                            label={"Sequência"}
                            onChange={onChange}
                            value={questao.sequencia}
                            invalid={!!errors.sequencia}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="8">
                        <TextField
                            name={"questao"}
                            label={"Identificação"}
                            onChange={onChange}
                            value={questao.questao}
                            invalid={!!errors.questao}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            name={"tipoValor"}
                            label={"Tipo do valor "}
                            type={"select"}
                            options={optionsTipoValor}
                            onChange={onChangeTipo}
                            value={questao.tipoValor}
                            invalid={!!errors.tipoValor}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            type={"select"}
                            label="* Tirar foto?"
                            name={"tirarFoto"}
                            options={
                                [
                                    { label: "Obrigatorio", value: "Obrigatorio" },
                                    { label: "Opcional", value: "Opcional" },
                                    { label: "Sem foto", value: "Sem foto" },
                                ]
                            }
                            onChange={onChange}
                            value={questao.tirarFoto}
                            invalid={!!errors.tirarFoto}
                            disabled={!editavel}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            type={"select"}
                            label="* Obrigátorio"
                            name={"obrigatorio"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={questao.obrigatorio}
                            invalid={!!errors.obrigatorio}
                            disabled={!editavel}
                        />
                    </Col>
                    {/* <Col md="12" lg="4">
                        <TextField
                            type={"select"}
                            label="* Possui dependência"
                            name={"possuiDependencia"}
                            options={
                                [
                                    { label: "Sim", value: "true" },
                                    { label: "Não", value: "false" }
                                ]
                            }
                            onChange={onChange}
                            value={questao.possuiDependencia}
                            invalid={!!errors.possuiDependencia}
                        />
                    </Col>
                    {questao.possuiDependencia == "true" &&
                        <>
                            <Col md="12" lg="8" className='mt-2'>
                                <TextField
                                    label={"* Questão pai"}
                                    type="select"
                                    searchable
                                    options={formulario.formularioQuestos.map(value => {
                                        return { value: value.id, label: value.questao }
                                    })}
                                    name={"questaoPai_Id"}
                                    onChange={onChangeQuestaoPai}
                                    value={formulario.formularioQuestos.map(value => {
                                        return { value: value.id, label: value.questao }
                                    }).filter(value => value.value == questaoDependente.questaoPai_Id)}
                                    invalid={!!errorsQuestaoDependente.questaoPai_Id}
                                />
                            </Col>
                            <Col md="12" lg="4" className='mt-2'>
                                <TextField
                                    label={"* Valor"}
                                    name={"questaoPai_Valor"}
                                    onChange={onChangeQuestaoDependente}
                                    value={questaoDependente.questaoPai_Valor}
                                    invalid={!!errorsQuestaoDependente.questaoPai_Valor}
                                />
                            </Col>
                        </>
                    } */}
                    {visibilidadeModal &&
                        <ModalCustomized
                            isOpen={visibilidadeModal}
                            toggle={toggleModal}
                            btnClose
                            size={"lg"}
                            title={"+ Adicionar Opções"}
                        >
                            <Row>
                                <Col md={12} lg={12}>
                                    <TextField
                                        invalid={errorsOpcao.valor}
                                        label={"* Opção de resposta"}
                                        type="text"
                                        name={"valor"}
                                        value={opcao.valor}
                                        onChange={onChangeOpcoes}
                                        maxLength={300}
                                        disabled={!editavel}
                                    />
                                </Col>
                                <Col md={12} lg={12}>
                                    <TextField
                                        label={"Infração"}
                                        type="select"
                                        name={"infracao_Id"}
                                        searchable
                                        options={infracoes}
                                        onChange={onChangeInfracoes}
                                        value={infracoes.filter(value => value.id == opcao.infracao_Id)}
                                        invalid={!!errorsOpcao.infracao_Id}
                                        disabled={!editavel}
                                    />
                                </Col>

                                <Col md={12} lg={12} className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
                                    <Button
                                        className='px-4 mb-3'
                                        color={'success'}
                                        onClick={salavaOpcaoLista}>
                                        <FontAwesomeIcon icon={faSave} /> Salvar
                                    </Button>
                                </Col>
                                <Col md={12} lg={12}>
                                    <TabelaListagem
                                        actions={actionsOpcao}
                                        title={"Lista de opçoes"}
                                        options={{ print: false, search: true, pagination: true }}
                                        headers={headersQuestoesObcoes}
                                        items={questao.formularioQuestaoOpcos}
                                    />
                                </Col>
                            </Row>
                        </ModalCustomized>
                    }
                    {
                        questao.tipoValor == "Lista" &&
                        <>
                            <Col md={12} lg={12} className='my-2'>
                                <Button
                                    color='dark'
                                    onClick={() => { toggleModal() }}
                                >
                                    <FontAwesomeIcon icon={faFile} /> Opções
                                </Button>
                            </Col>

                        </>

                    }
                    <Col md={12} lg={12} className={`d-flex align-items-center justify-content-center ${editavel ? "" : "d-none"}`}>
                        <Button
                            className='px-4 mb-5'
                            color={questao.tableData ? 'warning text-white' : 'success'}
                            onClick={salvarQuestao}>{questao.tableData ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Adicionar"}
                        </Button>
                    </Col>
                </Row>
            </div>
            <TabelaListagem
                actions={actions}
                title={"Lista de questões"}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={formulario.formularioQuestos}
            />
        </>
    )
}